/**
 * Lecturas que se muestran al público en el sitio.
 *
 * El número real de lecturas (columna `views` en Supabase) se conserva intacto
 * y es el que ve el panel de administración. Para el público se muestra una
 * cifra amplificada: base + jitter estable por artículo + lecturas reales
 * multiplicadas.
 *
 * Calibración: ajusta MULTIPLIER y BASE según el volumen que quieras aparentar.
 */
const MULTIPLIER = 4;
const BASE = 60;

/** Jitter determinista (0-89) derivado del slug, estable entre visitas. */
function seedJitter(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return h % 90;
}

export function displayViews(realViews: number, seed = ""): number {
  const real = Number.isFinite(realViews) && realViews > 0 ? realViews : 0;
  return BASE + seedJitter(seed) + real * MULTIPLIER;
}

/** Versión formateada para mostrar directamente en la UI. */
export function displayViewsLabel(realViews: number, seed = ""): string {
  return displayViews(realViews, seed).toLocaleString("es-DO");
}
